import ServiceBase from '../../ServiceBase';
import valuationProxy from '../../../proxies/market/market-in-depth/ValuationProxy';

class ValuationService extends ServiceBase {
  getValuationSeries(params, source) {
    return this.applyMemoryCache('MarketService.getValuationSeries', params)(
      () => valuationProxy.getValuationSeries(params, source),
    );
  }
}

const valuationService = new ValuationService();
export default valuationService;
